<app-table
  [data]="history"
  [columns]="columns"
></app-table>
